import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportVisualizationAdministrationComponent } from './transport-visualization-administration/transport-visualization-administration.component';
import { TransportVisualizationAdministrationWidgetComponent } from './transport-visualization-administration-widget/transport-visualization-administration-widget.component';
import { PagedContentModule, CommonUIElementsModule, CommonUIFormularModule, CommonUIButtonsModule, CommonLayoutModule, CommonUIBasicModule, TranslationComponentsModule } from '@sdbn/common';
import { TransportVisualizationRuleComponent } from './transport-visualization-administration/transport-visualization-rule/transport-visualization-rule.component';
import { CdkDrag, CdkDropList } from "@angular/cdk/drag-drop";
import { ConditionsModule } from "@sdbn/common-extended";
import { TransportVisualizationRuleEditorComponent } from './transport-visualization-administration/transport-visualization-rule-editor/transport-visualization-rule-editor.component'


@NgModule({
  declarations: [
    TransportVisualizationAdministrationComponent,
    TransportVisualizationAdministrationWidgetComponent,
    TransportVisualizationRuleComponent,
    TransportVisualizationRuleEditorComponent
  ],
  imports: [
    CommonModule,
    PagedContentModule,
    CommonUIElementsModule,
    CommonUIFormularModule,
    CommonUIButtonsModule,
    CommonLayoutModule,
    CommonUIBasicModule,
    ConditionsModule,
    CdkDropList,
    CdkDrag,
    TranslationComponentsModule
]
})
export class TransportVisualizationAdministrationModule { }
